import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, index, onClose, onNavigate }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNavigate(1);
      if (e.key === "ArrowLeft") onNavigate(-1);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onNavigate]);

  return (
    <AnimatePresence>
      {index !== null && (
        <motion.div
          data-testid="gallery-lightbox"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] flex items-center justify-center bg-navy/95 p-4 backdrop-blur-md"
          onClick={onClose}
        >
          <button data-testid="lightbox-close" aria-label="Close" onClick={onClose}
            className="absolute right-5 top-5 text-sand/70 transition-colors hover:text-gold">
            <X size={30} strokeWidth={1.5} />
          </button>
          <button data-testid="lightbox-prev" aria-label="Previous"
            onClick={(e) => { e.stopPropagation(); onNavigate(-1); }}
            className="absolute left-3 top-1/2 -translate-y-1/2 p-3 text-sand/70 transition-colors hover:text-gold">
            <ChevronLeft size={36} strokeWidth={1.5} />
          </button>
          <motion.img
            key={index}
            src={images[index].src}
            alt={images[index].alt}
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.35 }}
            className="max-h-[85vh] max-w-full border border-white/10 object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <button data-testid="lightbox-next" aria-label="Next"
            onClick={(e) => { e.stopPropagation(); onNavigate(1); }}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-3 text-sand/70 transition-colors hover:text-gold">
            <ChevronRight size={36} strokeWidth={1.5} />
          </button>
          <p className="absolute bottom-5 left-1/2 -translate-x-1/2 text-xs uppercase tracking-[0.25em] text-sand/60">
            {images[index].alt}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
